import * as d3 from 'd3'

export default {
  methods: {

    draw_ChartCanvas(itr) {
      this.chart.itrs[itr]
      this.canvasChart = this.canvasBoundary
      .append('g')
      .attr('class', 'CHART_CANVAS')
      .attr('transform', `translate(${this.chart.itrs[itr].x}, ${this.chart.itrs[itr].y})`)

      this.draw_ChartAxis()
      if(this.primary.grid == 'Y' || this.secondary.grid == 'Y') this.draw_Grid()
      this.draw_Legends()
    },

    
    draw_ChartAxis() {
      let axes = this.canvasChart

      axes
      .append('line')
      .attr('x1', 0).attr('x2', this.chart.width).attr('y1', this.chart.height).attr('y2', this.chart.height)
      .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', 1)

      if(this.primary.grid == 'Y') {
        axes
        .append('line')
        .attr('x1', 0).attr('x2', 0).attr('y1', 0).attr('y2', this.chart.height)
        .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', 1)
      }

      if(this.secondary.grid == 'Y') {
        axes
        .append('line')
        .attr('x1', this.chart.width).attr('x2', this.chart.width).attr('y1', 0).attr('y2', this.chart.height)
        .attr('stroke', '#757575' ).attr('stroke-width', .5).attr('opacity', 1)
      }
    },


    draw_Grid() {
      let tickRatio = 0

      if(this.chart.grid == 3) tickRatio = 0.333
      if(this.chart.grid == 5) tickRatio = 0.2


      let tick = this.chart.height * tickRatio
      let grids = this.canvasChart
      for(let i=0; i<(this.chart.grid+1); i++) {
        grids // Grid
        .append('line')
        .attr('x1', 0).attr('x2', this.chart.width)
        .attr('y1', tick * i).attr('y2', tick * i)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
        .attr('opacity', .5)

        if(this.primary.text == 'Y') {
          grids // Primary Axis
          .append('text')
          .attr('x', (this.primary.position == 'left') ? -2 : this.chart.width + 2)
          .attr('y', this.chart.height - (tick * i) + this.primary.tSize*0.36)  
          .attr('font-size', this.primary.tSize).attr('fill', this.primary.tColor)
          .attr('text-anchor', (this.primary.position == 'left') ? 'end': 'start')
          .text(()=> {
            let value = (this.primary.max * (i*tickRatio)).toFixed(0)
            if(this.primary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
            return value + this.primary.unit
          })
        }

        if(this.secondary.text == 'Y') {
          grids // Secondary Axis
          .append('text')
          .attr('x', (this.secondary.position == 'left') ? -2 : this.chart.width + 2)
          .attr('y', this.chart.height - (tick * i) + this.secondary.tSize*0.36)
          .attr('font-size', this.secondary.tSize).attr('fill', this.secondary.tColor)
          .attr('text-anchor', (this.secondary.position == 'left') ? 'end': 'start')
          .text( ()=> {
            let value = (this.secondary.max * (i*tickRatio)).toFixed(0)
            if(this.secondary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
            if(this.secondary.max < 3) value = (this.secondary.max * (i*tickRatio)).toFixed(0)
            return value + this.secondary.unit
          })
        }

      }
    },


    draw_Legends() {

      let item = this.canvasChart
      .append('g')
      .attr('id', `LEGEND_GROUP_${this.localId}`)
      .attr('transform', `translate(${0}, ${this.chart.height + 30})`)
      
      let x_ = 0
      this.chart.styles.forEach((d,i)=> {
        if(d.type == 'BAR') {
          item
          .append('rect')
          .attr('x', x_).attr('y', 0).attr('width', 6).attr('height', 6)
          .attr('fill', d.color)
        }

        if(d.type == 'LINE') {
          item
          .append('rect')
          .attr('x', x_).attr('y', 2).attr('width', 6).attr('height', 2)
          .attr('fill', d.color)
        }

        item
        .append('text')
        .attr('id', `LEGEND_${i}_${this.localId}`)
        .attr('transform', `translate(${x_ + 10}, ${3 + 9*0.36})`)
        .attr('font-size', 9).attr('fill', '#333')
        .text(d.name)

        x_ = x_ + this.getNode(`#LEGEND_${i}_${this.localId}`, 'width') + 20
      })

    },

  }
}